//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      activeTabbar: 0,
      
    };
  },
  props:['tabbar_list'],
  methods: {
  }
};
